import * as angular from "angular";

angular
  .module('bringoz.admin.self-pickups')
  .filter('pickupVehicleInfo', pickupVehicleInfo);

function pickupVehicleInfo() {
  return function pickupVehicleInfoFilter(vehicle) {
    if (vehicle) {
      const make: string = vehicle.make ? vehicle.make + ' ' : '';
      const model: string = vehicle.model ? vehicle.model + ' ' : '';
      const color: string = vehicle.color ? vehicle.color + ' ' : '';
      const plateNumber: string = vehicle.plateNumber ? ', ' + vehicle.plateNumber : '';
      return color + make + model + plateNumber;
    } else {
      return '---';
    }
  }
}
